"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLGTVAdapter = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const common_1 = require("../common");
function getDeviceInfo() {
    return new Promise((resolve, reject) => {
        if (!window.webOS) {
            return reject("window.webOS does not exist");
        }
        window.webOS.deviceInfo((deviceInfo) => {
            resolve(deviceInfo);
        });
    });
}
function getLGTVAdapter() {
    if (!(0, common_1.isLGTV)()) {
        if (window.navigator.userAgent.includes("Web0S")) {
            console.warn("[RedBeeMedia] You are using an LG TV, but the webOS javascript libraries are not loaded. The player may not function properly.");
        }
        return;
    }
    return () => __awaiter(this, void 0, void 0, function* () {
        const deviceInfo = yield getDeviceInfo();
        return {
            id: (0, js_player_shared_1.getDeviceId)(),
            type: "ctv",
            name: `LGTV ${deviceInfo.modelName}`,
            manufacturer: "lg",
            model: `lg-tv-${deviceInfo.sdkVersion}`,
            modelNumber: deviceInfo.modelName || "unknown",
            os: "WebOS",
            osVersion: deviceInfo.version,
        };
    });
}
exports.getLGTVAdapter = getLGTVAdapter;
//# sourceMappingURL=lg.js.map